import { render, staticRenderFns } from "./HelpCentre.vue?vue&type=template&id=5e2ed9f0&scoped=true"
import script from "./HelpCentre.vue?vue&type=script&lang=js"
export * from "./HelpCentre.vue?vue&type=script&lang=js"
import style0 from "./HelpCentre.vue?vue&type=style&index=0&id=5e2ed9f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2ed9f0",
  null
  
)

export default component.exports